import { SlideNavigationType } from "~/ui";

type ReturnType = {
  navigations: SlideNavigationType[];
};

type PropsType = {
  selectedArray: [boolean, boolean, boolean];
};

export const useAiCustomizeSlideNavigation = ({
  selectedArray,
}: PropsType): ReturnType => {
  const navigations = [
    {
      label: "全体",
      href: "/managers/ai_costomize/company_contexts",
      selected: selectedArray[0],
    },
    {
      label: "部署・課",
      href: "/managers/ai_costomize/business_section_contexts",
      selected: selectedArray[1],
    },
    {
      label: "投稿要約",
      href: "/managers/ai_costomize/company_post_summaries",
      selected: selectedArray[2],
    },
  ];

  return {
    navigations,
  };
};
